// The "Back to ..." link at the top of a shared detail page, the public
// route's stand-in for ItemBreadcrumbs (which names an item the viewer has no
// access to, and returns null without one anyway).
//
// THE `.container` IS THE POINT. Nothing wraps the shared routes: App.jsx puts
// no Container around <Routes>, and every page insets itself. Below this link
// that job is done by DataCard's own <Container className="py-3">, so a bare
// <p> here hugs the viewport while every card lines up an inch to its right --
// which is exactly what both of these links did. `.container` is the class
// react-bootstrap's <Container> emits, so the link and the cards resolve to one
// gutter and one max-width. ItemBreadcrumbs does the same thing on the owner's
// pages, for the same reason.
//
// The wrapper belongs HERE and not on the parent <div className="pb-2"> in
// SharedLogbookTrip / SharedTrip: a `.container` inside a `.container`
// re-applies the max-width and narrows every card on the page.
//
// mb-3 rather than mb-2: 1rem is Bootstrap's own `.breadcrumb` margin-bottom
// (nothing in App.css overrides it), so this keeps the owner pages' rhythm.

import { Link } from 'react-router-dom';

const SharedBackLink = ({ to, children }) => (
  <div className="container">
    <p className="mb-3">
      <Link to={to}>
        <i className="fa-solid fa-chevron-left me-1" aria-hidden="true"></i>
        {children}
      </Link>
    </p>
  </div>
);

export default SharedBackLink;
